exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-name[data-v-d2a34da2]{font-style:normal;font-weight:300;font-size:20px;line-height:23px;color:#000}.image-rounded[data-v-d2a34da2]{border-radius:100%;overflow:hidden;margin-right:10px}.profile-block[data-v-d2a34da2]{cursor:pointer}.profile-content[data-v-d2a34da2]{padding-top:7px}.profile-name[data-v-d2a34da2]{font-weight:300;font-size:17px;line-height:20px;color:#000;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.profile-ago[data-v-d2a34da2]{font-weight:400;font-size:11px;line-height:13px;color:#888}.viewAll[data-v-d2a34da2]{cursor:pointer;font-size:12px;line-height:14px;color:#555}", ""]);

// exports
